export const getSortedGradeYears = gradeYears => {
    return Array.isArray(gradeYears)
        ? [...gradeYears].sort(
              (prevGradeYear, currGradeYear) => prevGradeYear.year - currGradeYear.year,
          )
        : [];
};

export const getSortedAllStudentsGradeYears = allStudentsGradeYears =>
    Object.assign(
        {},
        ...allStudentsGradeYears.map(({ studentUid, gradeYears }) => ({
            [studentUid]: getSortedGradeYears(gradeYears),
        })),
    );

export const getGradeYearByStudentId = (response, studentId) => {
    const { gradeYears } = response.find(obj => obj.studentUid === studentId) || {};
    return gradeYears;
};
